import request from '@/utils/request'
const url = 'index.php/website/api/website/Login'
// const url = 'index.php/website/api/website/User'
// export function GetUserInfoByidentityCard(data) {
//     return request({
//         url: url +'User/GetUserInfoByidentityCard',
//         method: 'post',
//         data
//     })
// }


// export function logins(data) {
//     return request({
//         url: url+ 'WebsiteLogin/logins',
//         method: 'post',
//         data
//     })
// }



// //发送验证码
// export function SmsCheck(query) {
//     return request({
//         url: url +'/SmsCheck',
//         method: 'get',
//         params: query
//     })
// }

//身份证登录
export function GetCheckUserlog(query) {
    return request({
        url: url +'/GetCheckUserlog',
        method: 'get',
        params: query
    })
}

export function PostSaveByData(data) {
    return request({
        url: url +'/PostSaveByData',
        method: 'post',
        data
    })
}









